import type { JohaisetsuAreaName, SettouWorkType } from '@/lib/johaisetsu/johaisetsuCommonUtil';
import type { SettouPatrolReportRoadConditionMap } from '@/models/apis/johaisetsu/johaisetsuCommon';
import type {
  SettouPatrolReportRaw,
} from '@/models/johaisetsu/settouPatrol/settouPatrol/johaisetsuSettouPatrol';
import type {
  SettouOnsiteManagementReportRaw,
} from '@/models/johaisetsu/settouPatrol/settouOnsiteManagement/johaisetsuSettouOnsiteManagementReport';
import type { RoadNameDirection } from '@/models';
import type { JohaisetsuHan } from '@/models/apis/johaisetsu/johaisetsuHanMastersResponse';

export interface Pagination {
  currentPage: number;
  itemsPerPage: number;
}

export interface CommonSearchParams {
  dateFrom: Date;
  dateTo: Date;
  selectedWorkTypes: SettouWorkType[];
}

export interface PatrolSearchParams {
  roadNames: RoadNameDirection[];
  directionItem: string | null;
  roadConditionText: string | null;
}

export interface OnsiteManagementSearchParams {
  roadNames: RoadNameDirection[];
}

export const SETTOU_REPORT_TYPE_PATROL = 'patrol';
export const SETTOU_REPORT_TYPE_ONSITE_MANAGEMENT = 'onsiteManagement';
export type SettouReportType = typeof SETTOU_REPORT_TYPE_PATROL | typeof SETTOU_REPORT_TYPE_ONSITE_MANAGEMENT;

export interface SettouReport {
  id: number;
  ts: Date;
  workTypeDisplay: SettouWorkType;
  johaisetsuHanName: string;
  contentLines: string[];
  hasImage: boolean;
  reportType: SettouReportType;
  rawReport: SettouPatrolReportRaw | SettouOnsiteManagementReportRaw;
}

export interface SettouReportHanFilterState {
  johaisetsuArea: JohaisetsuAreaName | null;
  johaisetsuHanMasters: JohaisetsuHan[];
  selectedJohaisetsuHanNames: string[];
}

export interface SettouPatrolReportListState {
  isReady: boolean;
  isRequesting: boolean;
  isDownloading: boolean;

  settouReports: SettouReport[];

  roadNames: RoadNameDirection[];
  roadNameMap: Record<string, RoadNameDirection>;
  roadConditions: SettouPatrolReportRoadConditionMap[];
  roadConditionMap: { [key: string]: SettouPatrolReportRoadConditionMap };

  showErrorModal: boolean;
  errorBody: string;

  pager: Pagination;

  commonSearchParams: CommonSearchParams;
  patrolSearchParams: PatrolSearchParams;
  onsiteManagementSearchParams: OnsiteManagementSearchParams;
}
